import { SpinResponse } from '@cgs/data-access';
import {
  EndFreeSpinsPopupController,
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GAME_WIN_COMPONENT_TOKEN,
  GameStateMachine,
  GameWinComponent,
  IGameStateMachineProvider,
} from '@cgs/machines';

export class SantaEndFreeSpinsPopupController extends EndFreeSpinsPopupController {
  private readonly gameStateMachine: GameStateMachine<SpinResponse>;
  private readonly gameWinComponent: GameWinComponent;

  constructor(...args: ConstructorParameters<typeof EndFreeSpinsPopupController>) {
    super(...args);

    this.gameStateMachine = this.container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
    this.gameWinComponent = this.container.resolve<GameWinComponent>(GAME_WIN_COMPONENT_TOKEN);
  }

  public onCloseClicked(): void {
    super.onCloseClicked();
  }

  public onPopupClosed(): Promise<void> {
    this.gameWinComponent.addWin(
      this.gameStateMachine.curResponse.freeSpinsInfo!.totalWin +
        this.gameStateMachine.curResponse.freeSpinsInfo!.baseGameWin
    );

    return super.onPopupClosed();
  }
}
